import React, { useEffect } from 'react';
import { getCurrentUserSuccess, storeTokenToUser } from 'redux/actions/user';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import amplitudeHelper from 'helpers/Amplitude';

export default function RedirectManager() {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const authData = searchParams.get('auth_data');
  const user = useSelector((state) => state.user);
  const companyId = useSelector((state) => state.company.id);

  useEffect(() => {
    if (user.isTokenExpired || !user.isLoggedIn) {
      dispatch(getCurrentUserSuccess());
    }
  }, [user.isLoggedIn, user.isTokenExpired]);

  useEffect(() => {
    if (authData) {
      dispatch(storeTokenToUser(`Bearer ${authData}`));

      const googleAuthSource = localStorage.getItem('google_auth_source');
      if ((googleAuthSource && googleAuthSource === 'onboarding') || companyId == null) {
        window.location.href = '/onboarding?step=3';
        amplitudeHelper.logEvent('person_signed_up', { method: 'google' });
      } else {
        window.location.href = '/dashboard';
      }
    }
  }, [authData]);

  return null;
}
